import { default as _Vue, ComponentOptions } from 'vue';
import { Store } from 'vuex';
import logger, { Consola } from 'consola';
import { AbstractService } from '@/plugins/podolib/lib/AbstractService';
import { AbstractEventEmitterService } from '@/plugins/podolib/lib/AbstractEventService';

// Services
import CognitoService from '@/plugins/podolib/services/cognito';
import EntitiesService from '@/plugins/podolib/services/entities';
import AclService from '@/plugins/podolib/services/acl';
import Auth0Service from '@/plugins/podolib/services/auth0';
import BusService from '@/plugins/podolib/services/bus';
import HelperService from '@/plugins/podolib/services/helper';
import RepositoryService from '@/plugins/podolib/services/repository';
import StorageService from '@/plugins/podolib/services/storage';
import DoctorService from '@/plugins/podolib/services/doctor';
import AnalyticsService from '@/plugins/podolib/services/analytics';
import AnalysisService from '@/plugins/podolib/services/analysis';
import CommonsService from '@/plugins/podolib/services/commons';
import UpdateService from '@/plugins/podolib/services/update';

// Declarations ----------------------------------------------------------------
declare module 'vue/types/vue' {
  interface Vue {
    $pdc: PodoCore;
    $worker: any;
  }
}

declare module 'vue/types/options' {
  interface ComponentOptions<V extends _Vue> {
    pdc?: PodoCore;
  }
}

// Types -----------------------------------------------------------------------
export type TPluginDeclaration = Array<AbstractService<any, any> | AbstractEventEmitterService>;

/**
 * Core
 */
export default class PodoCore {
  [x: string]: any;

  // Plugin are used to extend the core functionalities
  private _plugins?: TPluginDeclaration;
  private _ready: boolean = false;
  private _logger: Consola = logger.withTag('core');

  public cognito?: CognitoService;
  public entities?: EntitiesService;
  public acl?: AclService;
  public auth0?: Auth0Service;
  public bus?: BusService;
  public helper?: HelperService;
  public repository?: RepositoryService;
  public storage?: StorageService;
  public doctor?: DoctorService;
  public analytics?: AnalyticsService;
  public analysis?: AnalysisService;
  public commons?: CommonsService;
  public update?: UpdateService;

  /**
   * Constructor
   * @param plugins
   */
  constructor(plugins: TPluginDeclaration) {
    this._plugins = plugins;

    this._logger.log(`🏗 Environment "${process.env.VUE_APP_BRANCH}" selected`);
  }

  /**
   * Init module
   *
   * @param Vue
   * @param store
   */
  async init(Vue: typeof _Vue, store: Store<any>) {
    // Inject core in Vue prototype
    Vue.prototype.$pdc = this;

    this._logger.withTag('services').log('🚧 Initialization ...');

    // Configure store root module
    store.registerModule('pdc', {
      namespaced: true,
    });

    await Promise.all(
      this._plugins!.map((x) => {
        this[x.serviceName] = x;
        x.init(Vue, store);
      }),
    );

    // Purge
    delete this._plugins;

    this._ready = true;
    this._logger.withTag('services').success('✅ All services are ready');
    console.log('> -------------------------------');
  }

  get ready(): boolean {
    return this._ready;
  }
}
